import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Image, Table, Modal, Form } from "react-bootstrap";
import EmptyRow from "../../components/emptyRow/EmptyRow";
import Edit from "../../assets/images/ic-edit.svg";
import icTitle from "../../assets/images/ic-edit-modal.svg";
import ENGModalBody from "../../components/modal/ENGModalBody";
import ENGModalHeader from "../../components/modal/ENGModalHeader";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { GetRoleListData,  selectRoleListData} from "../../features/rolebase/roleList";
import moduleList, { GetModuleListData, selectModuleListData } from "../../features/rolebase/moduleList";
import { GetSectorList,  selectSectorList} from "../../features/helpandassistance/SectorListSLice";
import { GetBusinessUnitList, selectBusinessUnitList} from "../../features/helpandassistance/BusinessUnitSlice";
import { GetUserListData, selectUserListData} from "../../features/rolebase/userList";
//import { GetUserListExcludedData, selectUserListExcludedData} from "../../features/rolebase/userListExcluded";

import { GetUpdateRole } from "../../features/rolebase/updateRole";
import ModuleRow from "./ModuleRow";
import { GetAdminListData, selectAdminListData } from "../../features/rolebase/adminList";
import EmailSelect from "../../components/textField/EmailSelect";
import UserGroupEditModal from "./UserGroupEditModal";


const UserGroup = () => {
  // Edit Modal Code
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  
  const dispatch = useAppDispatch();
  const RoleList = useAppSelector(selectRoleListData);
  const ModuleList = useAppSelector(selectModuleListData);
  const [roleName, setRoleName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [groupPermissions, setgroupPermissions]=useState<any>([]);
  const [rolePermissions, setRolePermissions]=useState()
  const [moduleDetails, setModuleDetails]=useState<any>()
  const [selectedSector, setSelectedSector]=useState([])
  const [selectedBu, setSelectedBu]=useState([])
  const [selectedUser, setSelectedUser]=useState([])
  const [buId, setBuId] = useState(selectedBu);
  const [sectorId, setSectorId] = useState(selectedSector);
  const [usersId, setUsersId] = useState(selectedUser);

  

  useEffect(() => {
    async function fetchRoleList() {
      await dispatch(GetRoleListData());
    }
    fetchRoleList();
    async function fetchModuleList() {
      await dispatch(GetModuleListData());
    }
    fetchModuleList();
 
  }, []);

  const SectorList:any = useAppSelector(selectSectorList);
  const BusinessUnitList:any = useAppSelector(selectBusinessUnitList);
  const UserList:any = useAppSelector(selectUserListData);

  const [sectorListData, setSectorListData]=useState([]);
  const [buListData, setBuListData]=useState([]);
  //const [userListData, setUserListData]=useState([]);

    useEffect(() => {
      async function fetchSectorData() {
        let sample = await dispatch(GetSectorList());
      }
      fetchSectorData();
    }, []);
    useEffect(()=>{
      setSectorListData(SectorList)
    },[SectorList])

    useEffect(() => {
      async function fetchBuData() {
        let sample = await dispatch(GetBusinessUnitList(sectorListData?.map((x:any) => x.sectorId)));
      }
      fetchBuData();
    }, [sectorListData]);
    useEffect(()=>{
      // setBuListData(BusinessUnitList)
      //console.log(BusinessUnitList)
    },[BusinessUnitList])

    // useEffect(() => {
    //   var data = {
    //     sectorId: sectorListData?.map((x:any) => x.sectorId),
    //     buId: buListData?.map((x:any) => x.sectorId),
    //   };
    //   async function fetchUserData() {
    //     let sample = await dispatch(GetUserListData(sectorListData?.map((x:any) => x.sectorId)));
    //   }
    //   fetchUserData();
    // }, [sectorListData, buListData]);
    // useEffect(()=>{
    //   setUserListData(UserList)
    // },[UserList])

 return (
    <>
      <Row>
        <Col lg={12}>
          <h4>Assign Role to User</h4>
        </Col>
      </Row>

      <div className="bgwhite b_shadow p_all mt-2 pt-2">
        <Row>
          <Col sm={10}>
            <h4>User Group</h4>
          </Col>

          <Col sm={2}>
            {/* <a href="/AssignRole">                     
                  <button style={styles.button}> Assign Role </button>
                 </a> */}
          </Col>
        </Row>
        <EmptyRow />

        <Table className="table table-bordered text-center table-striped">
          <thead>
            <tr>
              <th>Role Id</th>
              <th>Role Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {RoleList?.map((item: any) => {
              return (
                <tr key={item.roleId}>
                  <td>{item.roleId}</td>
                  <td>{item.roleName}</td>
                  <td>
                  <UserGroupEditModal  roleData={item} ModuleList={ModuleList} 
                  SectorList={SectorList} BusinessUnitList={BusinessUnitList} UserList={UserList}/>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    
    </>
  );
};

const styles: any = {
  DivGrey: {
    backgroundColor: "#fcfbfb",
    border: "1px solid #eee",
  },

  bottom: {
    marginBottom: "23%",
  },

  button: {
    backgroundColor: "#e31837",
    float: "right",
    padding: "10px",
    color: "#ffffff",
    border: "none",
  },
  checkmargin: {
    marginLeft: "15px",
  },

  imp: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "0px",
  },
  line: {
    margin: "23px 0px",
    backgroundColor: "#d8d8d8",
    height: "1.5px",
    padding: "0px",
  },

  content: {
    marginTop: "20px",
  },

 
  Checkbox: {
    marginTop: "7px",
  },

  user: { width: "40px" },
};

export default UserGroup;
